module.exports = __webpack_public_path__ + "static/media/all-resources.9eeed4e2.svg";